import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import zh from '@/utils/languages/zh/zh.js';
import en from '@/utils/languages/en/en.js';
import elementZhCn from 'element-ui/lib/locale/lang/zh-CN';
// import elementZhB5 from 'element-ui/lib/locale/lang/zh-TW';
import elementEng from 'element-ui/lib/locale/lang/en';

Vue.use(VueI18n)

const dateTimeFormats = {
  'zh-CN': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'zh-TW': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
}

const i18n = new VueI18n({
	locale: localStorage.getItem('lang') || 'zh-CN',
	// locale: 'zh-CN',
	messages: {
		'zh-CN': {
			...zh,
      ...elementZhCn,
		},
		'en-US': {
			...en,
      ...elementEng,
		}
	},
  dateTimeFormats,
  silentTranslationWarn: true
});
ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n
